import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/internal/operators/catchError';
import { RouterConstants } from '../constants/app-paths.constant';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor() {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
                   .pipe(catchError(err => {
            if (
                (err?.status === 403 && err?.error && err?.error.indexOf("HTTP Status 403 – Forbidden") !== -1) || 
                (err?.status === 401 && err?.error?.message === "The incoming token has expired")
            ) {
                // auto logout if 401 response returned from api
                //Redirecting to login in above 2 cases 
                location.assign(RouterConstants.SLASH);
                sessionStorage.clear();
            }
            else if (err.status === 400){
                return throwError(err.error);
            } else if ( err.status === 406) {
                return throwError(err.error);
            }

            const error = (err?.error) ? err.error.message : err.statusText;

            return throwError(error);
        }));
    }
}
